<template>
  <v-dialog
    content-class="dialog-custom"
    v-model="dialog"
    persistent
    width="450px"
  >
    <v-card light>
      <div>
        <div v-if = "step !== 3 && !finalStep !== 2" style="position: absolute; right: 0; padding-top: 10px">
          <v-btn class="mx-2" icon title="Close Form" @click="handleDialogClose">
            <v-icon class="material-icons-round"> close </v-icon>
          </v-btn>
        </div>
        <div v-if = "!isLoading" class = "textDiv">
          <p v-if = "step === 1" class = "accountText">Add an account photo</p>
          <p v-if = "step === 2" class = "accountText">Looking Good!</p>
        </div>
      </div>
      <v-card-title>
        <div class = "loadingContainer" v-if="isLoading">
            <v-progress-circular
              indeterminate
              class = "loader"
              ></v-progress-circular>
        </div>
        <fileUploadArea
          style="width: 100%; padding-top: 12px"
          v-if="step === 1 && !isLoading"
          :hideText="hideText"
          :hideMultipleFile="hideMultipleFile"
          @filesSelected="filesSelected"
        />
        <div v-if="step === 2 && !isLoading" class="imageContainer">
          <div class="profile-img">
            <img :src="userSelfieImage" class="img-fluid" alt="" />
          </div>
          <div class = "buttonContainer">
            <button class="buttonCancel btn_new btn-secondary-new" @click="handleDialogClose">Cancel </button>
            <button class="buttonSubmit btn_new btn-secondary-new" @click="submitProfile">Save </button>
          </div>
        </div>
        <div v-if = "step === 3 && !isLoading">
            <div v-if = "finalStep === 1" class="imageContainer">
              <img src = '/img/Success.svg'>
              <p class = "successfulText">Successful</p>
            </div>
            <div v-if = "finalStep === 2" class="imageContainer">
              <img src = '/img/Failure.svg'>
              <p class = "failureText">Failed</p>
              <button class="buttonRetry btn_new btn-secondary-new" @click="retryEditProfile">Retry </button>
            </div>
        </div>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import fileUploadArea from '@/components/common/fileUploadArea.vue'
import Compressor from 'compressorjs'
import onboardingService from '@/services/lenderOnboardingService'
export default {
    name: 'editProfileDialog',
    components: {
        fileUploadArea
    },
    props: {
        showEditProfileDialog: Boolean
    },
    data () {
        return {
            dialog: this.showEditProfileDialog,
            step: 1,
            hideText: true,
            hideMultipleFile: true,
            selectedFile: null,
            userSelfieImage: '',
            livenessResponse: null,
            isLoading: false,
            finalStep: null
        }
    },
    methods: {
        timeFunction () {
            setTimeout(() => {
                this.handleDialogClose()
            }, 800)
        },
        retryEditProfile () {
            this.isLoading = true
            this.step = 1
            this.selectedFile = null
            this.userSelfieImage = ''
            this.livenessResponse = null
            this.finalStep = null
            this.isLoading = false
        },
        handleDialogClose () {
            this.$emit('closeDialog')
        },
        filesSelected (files) {
            this.selectedFile = files[0]
            this.step++
            this.isLoading = true
            this.handleImage()
        },
        async handleImage () {
            const selectedImage = this.selectedFile
            const comp = new Compressor(selectedImage, { quality: 0.6 })
            comp.done = (e) => {
                if (e?.result?.size < 3000000) {
                    this.createBase64Image(e.result)
                    this.isLoading = false
                } else {
                    this.displayImageSizeError()
                    this.isLoading = false
                }
            }
            // this.isLoading = false
        },
        createBase64Image (fileObject) {
            const reader = new FileReader()
            reader.onload = (e) => {
                let base64 = e.target.result
                base64 = base64.split(',')[1]
                this.userSelfie = base64
                this.userSelfieImage = 'data:' + fileObject.type + ';base64,' + base64
            }
            reader.readAsDataURL(fileObject)
        },
        displayImageSizeError () {
            this.step = 3
            this.finalStep = 2
        },
        async submitProfile () {
            this.isLoading = true
            await onboardingService.sendProfileImage({ userSelfie: this.userSelfie, livenessResponse: this.livenessResponse }).then((res) => {
                if (res.status === 200) {
                    this.isLoading = false
                    this.$store.state.dashboard.profileImage = this.userSelfieImage
                    // this.$store.dispatch('dashboard/setField', { field: 'profileImage', value: res.data.userSelfie.Location })
                    this.step = 3
                    this.finalStep = 1
                    this.timeFunction()
                } else {
                    this.isLoading = false
                    this.step = 3
                    this.finalStep = 2
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.v-card__title {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
  line-height: 24px;
  word-break: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-custom {
  height: 120px !important;
  background: #ffffff;
  border: 1px solid #b9b9bb !important;
  box-sizing: border-box !important;
  border-radius: 21px !important;

  .v-card__actions {
    padding: 20px !important;
  }
}

.v-text-field .v-label {
  font-weight: bold !important;
}
.dialog-header-custom {
  width: 200px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.custom-btn-common {
  width: 150px;
  font-size: 14px;
  text-transform: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;
}

.custom-btn {
  background-color: #ffcb05 !important;
  font-size: 14px;
  text-transform: none;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;

  .v-icon {
    font-size: 14px;
    margin-left: 16px;
  }
}
.profile-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-top: 50px;
    margin-bottom: 50px;
    border-radius: 200px;
    width: 130px;
    height: 130px;
  }
}
.imageContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.buttonContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.buttonCancel {
  height: 40px !important;
  background: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
  font-size: 14px !important;
  color: #4F4F4F !important;
  margin-right: 20px !important;
  padding-right: 10px !important;
  width: 100px !important;
}
.buttonSubmit {
  height: 40px !important;
  font-size: 14px !important;
  margin-left: 20px !important;
  padding-left: 10px !important;
  width: 100px !important;
}
.buttonRetry {
  height: 40px !important;
  background: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
  font-size: 14px !important;
  font-weight: 500;
  color: #232323 !important;
  width: 180px !important;
  margin-top: 30px
}
.textDiv {
  position: absolute;
  padding-top: 15px;
  padding-left: 12px;
}
.accountText {
  padding-left: 16px;
  font-size: 16px !important;
  font-weight: 600;
  color: #232323
}
.loadingContainer {
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.loader {
    padding-top: 200px;
    height: 42px !important;
    width: 42px !important;
    color: #007AFF;
}
.successfulText {
  font-size: 21px;
  padding-top: 25px;
  font-weight: 700;
  color: #27ae60
}
.failureText {
  font-size: 21px;
  padding-top: 25px;
  font-weight: 700;
  color: #F21E1E
}
</style>
